import reduxStore from '../reduxStore.js';
import isEmpty from 'lodash/isEmpty';
import some from 'lodash/some';
import { authManager } from './managers';

export const assignTrackUrlToken = (episode, forceRefresh = true) => {
  // console.log(episode);
  return new Promise(async resolve => {
    let { url, publicEpisode = false } = episode;
    try {
      const { userInfo } = reduxStore.getState().user;
      // console.log('userInfo', userInfo);

      if (process.env.NODE_ENV === 'dev') {
        url = url.replace('https://app.mysoundwise.com', 'http://localhost:3000');
      }

      if (process.env.NODE_ENV === 'staging') {
        url = url.replace('https://app.mysoundwise.com', 'https://preprod.mysoundwise.com');
      }

      // ignore when userInfo is empty
      // the episode is public
      // if (some([isEmpty(userInfo), publicEpisode], Boolean)) {
      //   return resolve(url);
      // }

      // get the idtoken of the firebase user
      const idtoken = await new Promise(resolve => {
        authManager
          .getCurrentUser()
          .getIdToken(forceRefresh)
          .then(resolve)
          .catch(() => {
            resolve('');
          });
      });

      if (isEmpty(idtoken)) {
        return resolve(url);
      }

      resolve(`${url}?idtoken=${idtoken}`);
    } catch (error) {
      resolve(url);
    }
  });
};
